export default {
    symbolsKeyValue: "Abc",
    layout: [
        ["q", "w", "e", "r", "t", "z", "u", "i", "o", "p"], // QWERTZ: z instead of y
        ["a", "s", "d", "f", "g", "h", "j", "k", "l"],
        ["y", "x", "c", "v", "b", "n", "m"] // QWERTZ: y instead of z
    ],
    specialKeysLayout: ["ě", "š", "č", "ř", "ž", "ý", "á", "í", "é", "ú", "ů", "ň", "ť", "ď"],
    specialKeysLabel: "ěščř"
};
